/**
 * @file browserBugFixed.js
 * @description 浏览器bug修复
 */

import cssSupport from '../cssSupport';

/**
 * 修复safari的z-index失效问题
 */
const fixedSafariBug = () => {
    const isSafari = /Safari/.test(navigator.userAgent)
        && !/Chrome/.test(navigator.userAgent);
    const scrollTop = window.pageYOffset;
    // 修复safari下的header遮挡问题
    if (isSafari && document.getElementById('sticky')) {
        if (+scrollTop < 120) {
            document.getElementById('sticky').style.setProperty('z-index', 0);
        }
        else {
            document.getElementById('sticky').style.setProperty('z-index', 8);
        }
    }
};

/**
 * 修复低版本浏览器的sticky属性兼容问题
 */
const fixedStickyBug = () => {
    // 判断是否兼容sticky属性
    const isSupportSticky = cssSupport('position', 'sticky');
    const scrollTop = window.pageYOffset;
    // 如果不支持
    if (!isSupportSticky && document.getElementById('sticky')) {
        if (+scrollTop < 120) {
            document.getElementById('sticky').style.setProperty('position', 'relative');
        }
        else {
            document.getElementById('sticky').style.setProperty('position', 'fixed');
        }
    }
};

export const fixBugs = () => {
    fixedSafariBug();
    fixedStickyBug();
};
